module.exports = __webpack_public_path__ + "img/vipto2.14f9e315.png";